import React, {Fragment, useEffect} from 'react';
import {isMobile} from 'react-device-detect';
import {connect} from 'react-redux';
import {setSelectedHetPayAllowedToActions, setSelectedHetPay} from '../PortalsBlock/portalSlice';
import {setBusinessIndividualActiveStep, setSearchedPackages, saveToHistory} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';

import {businessIndividualSteps} from '../../Block/CellcomAbroadLobbyBlock/cellcomAbroadVariables';
import {Col, Row} from 'reactstrap';
import HeadLineComponent from './HeadlineComponent';
import ReactSelect from '../../Shared/ReactSelect/ReactSelect';
import DeniedMessageBox from '../../Shared/DeniedMessageBox/DeniedMessageBox';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import {
  gaSelectedCompanyIsNotAllowed,
  gaNotAllowedCallBackClick,
  gaSelectCompanyComponentView,
  gaSelectingCampaign,
  gaSelectingCampaignContinueClick,
  gaOnlyOneAndNotAllowed,
  gaNotAllowedForDefaultCallBackClick,
  gaSelectCompanyFinishButtonClick,
} from './GaReports';

const SelectCompanyComponent = (props) => {
  const selectBoxObj = [];

  props.portalsBlock.hetPaysNumbers.map((org) => {
    let item = {key: org.id, value: org.name + ' ' + org.id};
    selectBoxObj.push(item);
  });

  const messageText = `מצטערים אין לך הרשאה לבצע את הפעולה עבור חברה זו`;
  const subMessageText = `חיוג 234* לעדכון ההרשאה`;

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
    if (props.portalsBlock.hetPaysNumbers.length === 1 || (props.portalsBlock.selectedHetPay && props.portalsBlock.skipSelectCompanyStep)) {
      validateDefaultCompany();
    } else {
      gaSelectCompanyComponentView();
    }
  }, []);

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
  }, [props.portalsBlock.selectedHetPay]);

  const validateDefaultCompany = () => {
    const selectedCompany = !props.portalsBlock.selectedHetPay
      ? props.portalsBlock.hetPaysNumbers[0].id
      : props.portalsBlock.selectedHetPay;
    validateSelectedOrg(selectedCompany);
  };

  const validateSelectedOrg = (selectedOrgId) => {
    props.setSelectedHetPayAllowedToActions(true);

    if (selectedOrgId) {
      if (props.data.abroadPackagesList?.length > 0) {
        props.setSearchedPackages(null);
      }

      props.setSelectedHetPay(selectedOrgId);
      const selectedOrg = props.portalsBlock.privateCompanyList.find((org) => org.idNumber == selectedOrgId);

      if (!selectedOrg.cellInd || !selectedOrg.allowedCellular) {
        props.setSelectedHetPayAllowedToActions(false);
        if (props.portalsBlock.hetPaysNumbers.length === 1) {
          gaOnlyOneAndNotAllowed();
        } else {
          gaSelectedCompanyIsNotAllowed();
        }
      } else {
        if (
          props.portalsBlock.hetPaysNumbers.length === 1 ||
          (props.portalsBlock.selectedHetPay && props.portalsBlock.skipSelectCompanyStep)
        ) {
          props.setBusinessIndividualActiveStep(businessIndividualSteps.SELECT_ACCOUNT);
        } else {
          gaSelectingCampaign();
        }
      }
    }
  };

  const saveToHistoryAngGo = () => {
    gaSelectingCampaignContinueClick();
    props.saveToHistory();
    props.setBusinessIndividualActiveStep(businessIndividualSteps.SELECT_ACCOUNT);
  };
  const gaAndGoToBusinessLobby = () => {
    gaSelectCompanyFinishButtonClick();
    props.gaAndGoToBusinessLobby();
  };

  return (
    <>
      <HeadLineComponent title={`${window.Config.brand_Name_HE} חו״ל`} boldTitle={'בחירת ח.פ'} />
      <Row>
        <Col>
          <div className={`background-container`}>
            <p className='bold text-right'>עבור איזה ח.פ ברצונך לבקש שירות?</p>
            <ReactSelect
              //className = {`${props.portalsBlock.hetPaysNumbers.length === 1 ? "disabled": ""}`}
              getOptionLabel={(option) => option.value}
              getOptionValue={(option) => option.key}
              placeholder='בחירת ח.פ.'
              value={selectBoxObj.filter((option) => option.key == props.portalsBlock.selectedHetPay)}
              name='selected'
              options={selectBoxObj}
              onChange={(e) => validateSelectedOrg(e.key)}
            />
          </div>
        </Col>
      </Row>

      {props.portalsBlock.selectedHetPay && !props.portalsBlock.selectedHetPayAllowedToActions && (
        <Row>
          <Col>
            <DeniedMessageBox
              onclick={props.portalsBlock.hetPaysNumbers.length === 1 ? gaNotAllowedForDefaultCallBackClick : gaNotAllowedCallBackClick}
              text={messageText}
              subText={subMessageText}
              asBtn={isMobile ? true : false}
              tel={window.Config.businessCallNumber}
            />
          </Col>
        </Row>
      )}

      <Row className='justify-content-md-center mt-75'>
        <Col xs='12' className={`${!props.portalsBlock.selectedHetPay ? 'disabled-btn' : ''} btn-220 btn-row pr-0 pl-0 text-center `}>
          <BtnSubmit
            isBusiness
            text={`${props.portalsBlock.selectedHetPayAllowedToActions ? 'המשך' : 'סיום'}`}
            onclick={() => {
              !props.portalsBlock.selectedHetPayAllowedToActions ? gaAndGoToBusinessLobby() : saveToHistoryAngGo();
            }}
          />
        </Col>
      </Row>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.cellcomAbroad,
    portalsBlock: state.portalsBlock,
  };
};

const mapDispatchToProps = {
  setSelectedHetPayAllowedToActions,
  setSelectedHetPay,
  setBusinessIndividualActiveStep,
  setSearchedPackages,
  saveToHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectCompanyComponent);
